export default (foldCount = 0, isOpenedDefault = true) => ({
	openedIndices: Array(foldCount).fill(isOpenedDefault),
	toggle(index) {
		this.openedIndices[index] = !this.openedIndices[index];
	},
	isOpen(index) {
		return this.openedIndices[index];
	},
});
